// export const CUSTOMER_SITE_PROXY_URL = 'https://billing-server-dev.towersystems.com.au';
export const CUSTOMER_SITE_PROXY_URL = 'https://billing-server.towersystems.com.au';
// export const CUSTOMER_SITE_PROXY_URL = 'http://192.168.1.137:8000';

export const OAUTH2_SERVER_URL = 'https://billing-server.towersystems.com.au';
// export const OAUTH2_SERVER_URL = 'http://192.168.1.137:8000';

// Set this to the public URL of this app (used as the OAuth2 return_url)
export const CLIENT_URL = 'https://billing.towersystems.com.au';
// export const CLIENT_URL = 'http://localhost:3002';